// add the following to the application's webpack.config.js file
// app: path.resolve(__dirname, 'assets/js')
import routes from "app/routes";
import Routing from "fosjsrouting/router";

Routing.setRoutingData(routes);
export default Routing;
